import { useDispatch } from "react-redux";
import { addCartToWishlist } from "~/features/wishlist/redux/actions";
import BulkAddToWishlistFlow, {
  type BulkAddToWishlistFlowProps,
} from "~/features/orders/orderDetails/components/AddToWishlist/BulkAddToWishlistFlow";

type SelfProps = Pick<BulkAddToWishlistFlowProps, "onClose" | "info">;

export default function AddCartToWishlistPopupFlow(props: SelfProps) {
  const { onClose, info } = props;
  const dispatch = useDispatch();

  const handleAddToWishlist = (data: { wishlistId: string } | { wishlistName: string }) => {
    return dispatch(addCartToWishlist(data));
  };

  return <BulkAddToWishlistFlow onClose={onClose} onAddToWishlist={handleAddToWishlist} info={info} />;
}
